import React from 'react';
import { SMALL_MODAL_WIDTH } from '../../../constants/ForestConstant';

const CenterLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div className="d-flex align-items-center justify-content-center w-100" style={{ minHeight: '100%' }}>
      <div className="flex-grow-1" style={{ maxWidth: SMALL_MODAL_WIDTH }}>
        {children}
      </div>
    </div>
  );
};

export default CenterLayout;
